import React, { Fragment } from "react";

import { Container } from "../../components";
import { lazyWithRetry } from "../../core/lazy_with_retry";
import { Spacer } from "../spacer";
import { GeneralInformation } from "../template_offering_details_base";
import { OfferingDetailsMultiPass } from "../template_offering_details_multipass";
import { Text } from "../text";
import { TextLink } from "../text_link";
import { useWerqwiseAnalytics } from "./werqwise_analytics";
import { partnerConfig, testimonials } from "./werqwise_partner_config";

const Theme = lazyWithRetry(() => import("./werqwise_theme"));

const faqs = [
  {
    question: "Do I need to book in advance to use my Multi-Pass?",
    answer:
      "Yes. You will need to book ahead of time. When possible, we will accommodate walk-ins according to availability.",
  },

  {
    question: "Can I cancel my Multi-Pass purchase?",
    answer: "Unfortunately, the Multi-Pass is non-refundable.",
  },

  {
    question: "Can I share my passes with other people?",
    answer:
      "No. The Multi-Pass is for personal use only and is not transferable.",
  },

  {
    question: "Can I use the meeting rooms?",
    answer: (
      <Text>
        Yes you can book meeting rooms on an hourly basis. The meeting rooms are
        charged at an hourly rate. Please contact the front desk for
        availability and pricing options or{" "}
        <TextLink href="/offerings/werqwise-meeting-rooms">
          book on-demand here.
        </TextLink>
      </Text>
    ),
  },

  {
    question: "Can I use the printer?",
    answer: "Yes, please approach the front desk and we will assist you.",
  },

  {
    question:
      "Can I meet with clients or bring a guest into the lounges and common areas?",
    answer:
      "Your pass is for personal use and doesn’t cover guests. You will have to purchase a Day Pass for your guest.",
  },

  {
    question: "Where can I keep and heat my lunch?",
    answer:
      "The kitchen, refrigerator and microwave is available for your use. ",
  },

  {
    question: "Do you offer coffee, tea, or water?",
    answer: "We offer freshly brewed coffee.",
  },
];

const generalInfo: GeneralInformation = {
  title: `General information and cancellation policy`,
  description: "",
  bulletPoints: [
    {
      point: "Cancellation and Changes",
      text: "You may cancel your reservation 24 hours before the reservation begins.",
    },
    {
      point: "Your work area",
      text: "The day pass gives you access to work from common areas and lounges. Phone booths (when vacant) are available for phone and Zoom calls.",
    },
    {
      point: "Expiration",
      text: "Your multi-pass is valid for 30 days.",
    },
    {
      point: "Health and safety",
      text: "We've updated our space to help you make better choices. From installing our new temperature gate to adding hand sanitizer fixtures, we have added a variety of different ways for you to stay healthy and clean.",
    },
  ],
};

export function OfferingWerqwiseMultiPass() {
  useWerqwiseAnalytics();

  return (
    <Fragment>
      <Theme />
      <OfferingDetailsMultiPass
        showAddress={false}
        showDirections
        partnerConfig={partnerConfig}
        data={{
          description: (
            <Container>
              <Text>
                The Werqwise lounge multi-pass is perfect when you want to come
                in a couple of times a week. Purchase your day passes in bulk at
                a lower price without a long term commitment.
              </Text>
              <Spacer size={16} />
              <Text>
                Enjoy Werqwise membership benefits while working from a creative
                and inspiring environment.
              </Text>
            </Container>
          ),
          faqs,
          testimonials: testimonials,
          generalInfo: generalInfo,
        }}
      />
    </Fragment>
  );
}
